import { FC } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';

//* 응답 시간 안내는 우리가 업무로 응대하는 계정에게만 보인다 —
//* 상조 직원(worker) 이상, 관리자, 판매자 계열. 게스트 구매자·비로그인 문의는
//* 응대 주체와 속도가 달라 약속하지 않는다.
export const EnquiryResponseTimeNotice: FC = () => {
  const {
    isAdmin,
    isBugoAgencyAdmin,
    isBugoAgencyBranchAdmin,
    isBugoAgencyWorker,
    isStoreSeller,
    isGiftAgent,
    isGiftBrandSeller,
  } = useAuth();

  const isStaff =
    isAdmin() ||
    isBugoAgencyAdmin() ||
    isBugoAgencyBranchAdmin() ||
    isBugoAgencyWorker() ||
    isStoreSeller() ||
    isGiftAgent() ||
    isGiftBrandSeller();

  if (!isStaff) return null;

  return (
    <div className="flex justify-center">
      <div className="flex items-center gap-x-2 rounded-full border border-gray-200 bg-white px-4 py-2 shadow-sm">
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" />
        </span>
        <p className="text-sm font-medium text-gray-800">보통 10분 이내에 답변드려요</p>
      </div>
    </div>
  );
};
